import { css } from '@emotion/core'

export const iconCSS = css`
display: inline-flex;
font-family: Icon;
font-variation-settings: 'wght' 200;
font-size: 18px;
line-height: 30px;
align-items: center;
justify-content: center;
`
